import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "signIn",
    component: () => import("@/views/signIn.vue"),
  },
  //  视频学习
  {
    path: "/videoLearning",
    name: "videoLearning",
    component: () => import("@/views/videoLearning.vue"),
  },
  //  答题
  {
    path: "/answerQuestions",
    name: "answerQuestions",
    component: () => import("@/views/answerQuestions.vue"),
  },
  //  答题结果
  {
    path: "/answerExam",
    name: "answerExam",
    component: () => import("@/views/answerExam.vue"),
  },
  //  出车前安全检查表
  {
    path: "/cheInspectionRead",
    name: "cheInspectionRead",
    component: () => import("@/views/cheInspectionRead.vue"),
  },
  //  安卓隐私协议
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("@/views/privacyPolicy.vue"),
  },
  // 安卓行准入规则和承诺
  {
    path: "/admittanceRule",
    name: "admittanceRule",
    component: () => import("@/views/admittanceRule.vue"),
  },
  // 小程序用户协议
  {
    path: "/userProtocol",
    name: "userProtocol",
    meta: {
      title: "用户协议",
    },
    component: () => import("@/views/userProtocol.vue"),
  },
  // 小程序隐私政策
  {
    path: "/uniprivacyPolicy",
    name: "uniprivacyPolicy",
    meta: {
      title: "隐私政策",
    },
    component: () => import("@/views/uniprivacyPolicy.vue"),
  },
  // 小程序用车规则
  {
    path: "/rules",
    name: "rules",
    meta: {
      title: "用车及计费规则",
    },
    component: () => import("@/views/rules.vue"),
  },
  // 司机端  加入“G5行”的个人信息授权书
  {
    path: "/personalInfoAuth",
    name: "personalInfoAuth",
    meta: {
      title: "加入“G5行”的个人信息授权书",
    },
    component: () => import("@/views/personalInfoAuth.vue"),
  },
  // 司机端  “G5行”平台服务协议
  {
    path: "/platformProtocal",
    name: "platformProtocal",
    meta: {
      title: "“G5行”平台服务协议",
    },
    component: () => import("@/views/platformProtocal.vue"),
  },
  // 代理商推广司机注册
  {
    path: "/registerSiji",
    name: "registerSiji",
    meta: {
      title: "注册司机",
    },
    component: () => import("@/views/registerSiji.vue"),
  },
  // 代理商推广司机注册后跳转
  {
    path: "/registerTodownload",
    name: "registerTodownload",
    meta: {
      title: "G5行",
    },
    component: () => import("@/views/registerTodownload.vue"),
  },
  // 司机端活动奖励图片
  {
    path: "/chauffeurTaskReward",
    name: "chauffeurTaskReward",
    meta: {
      title: "活动奖励",
    },
    component: () => import("@/views/chauffeurTaskReward.vue"),
  },
  // 司机端下载页面
  {
    path: "/appDownload",
    name: "appDownload",
    meta: {
      title: "G5行司机端下载",
    },
    component: () => import("@/views/appDownload.vue"),
  },
  // 小程序用户推广登录
  {
    path: "/promotionLogin",
    name: "promotionLogin",
    meta: {
      title: "小程序用户推广登录",
    },
    component: () => import("@/views/promotionLogin.vue"),
  },
  // 小程序用户推广详情
  {
    path: "/promotionDetail",
    name: "promotionDetail",
    meta: {
      title: "小程序用户推广详情",
    },
    component: () => import("@/views/promotionDetail.vue"),
  },
  // 小程序用户推广码
  {
    path: "/promotionCode",
    name: "promotionCode",
    meta: {
      title: "小程序用户推广码",
    },
    component: () => import("@/views/promotionCode.vue"),
  },
  // 乘客端下载页面
  {
    path: "/passengerApp",
    name: "passengerApp",
    meta: {
      title: "G5行乘客端下载",
    },
    component: () => import("@/views/passengerApp.vue"),
  },
  // 司机端提现规则
  {
    path: "/withdrawDeposit",
    name: "withdrawDeposit",
    meta: {
      title: "提现规则",
    },
    component: () => import("@/views/withdrawDeposit.vue"),
  },
  // 关于我们
  {
    path: "/aboutus",
    name: "aboutUs",
    meta: {
      title: "关于我们",
    },
    component: () => import("@/views/aboutUs.vue"),
  },
  // 手表订单音频播放
  {
    path: "/watchOrderAudio",
    name: "watchOrderAudio",
    meta: {
      title: "订单录音",
    },
    component: () => import("@/views/watchOrderAudio.vue"),
  },
  // 拾州购代理商快速注册
  {
    path: "/registerAgent",
    name: "registerAgent",
    meta: {
      title: "拾州购代理商快速注册",
    },
    component: () => import("@/views/registerAgent.vue"),
  },
  // 拾州购地推官快速注册
  {
    path: "/registerDitui",
    name: "registerDitui",
    meta: {
      title: "拾州购地推官快速注册",
    },
    component: () => import("@/views/registerDitui.vue"),
  },
  {
    path: "/heatMap",
    name: "heatMap",
    meta: {
      title: "热力图",
    },
    component: () => import("@/views/heatMap.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});
//全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  next();
});
router.afterEach((to, from) => {});
export default router;
